export const siteSettings = {
  name: "Pair Dex",
  link: "https://thepairdex.net",
  email: "support@thepairdex.net",
  appLink: "https://app.thepairdex.net",
};
